export const initialTournamentData = {
    name: '',
};
